import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "4c1775a2-53ff-4f73-89da-e16212d889af",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 83,
      y: 54,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "815a2d43-a19b-46ae-881b-39afd5538040",
      type: "Sprite",
      name: "photo",
      nameSpace: "",
      className: "",
      x: -38,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.0625,
        y: 1.0625
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "",
      parent: "4c1775a2-53ff-4f73-89da-e16212d889af",
      data: ""
    },
    {
      id: "55bf2591-a800-47c3-8130-f7d05c749574",
      type: "Sprite",
      name: "bg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "friends_cover_1",
      parent: "4c1775a2-53ff-4f73-89da-e16212d889af",
      data: ""
    },
    {
      id: "0f39bdd2-71a6-4fc8-b25f-14d68d4e75ba",
      type: "Text",
      name: "nameText",
      nameSpace: "",
      className: "",
      x: 5,
      y: -14,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Friend",
      localize: false,
      maxWidth: 110,
      maxHeight: 41,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#712F14",
        stroke: "black",
        strokeThickness: 0,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "4c1775a2-53ff-4f73-89da-e16212d889af",
      data: ""
    },
    {
      id: "59ddcdd2-25bd-4286-ad83-42d3b87d68b9",
      type: "Text",
      name: "scoreText",
      nameSpace: "",
      className: "",
      x: 5,
      y: 15,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "1200000",
      localize: false,
      maxWidth: 104,
      maxHeight: 32,
      maxFontSize: 24,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "#712F14",
        strokeThickness: 3,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "4c1775a2-53ff-4f73-89da-e16212d889af",
      data: ""
    },
    {
      id: "f88c26a1-ece9-413f-bb40-47c52c1243af",
      type: "Sprite",
      name: "coin",
      nameSpace: "",
      className: "",
      x: 147,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "friends_coin2",
      parent: "4c1775a2-53ff-4f73-89da-e16212d889af",
      data: ""
    },
    {
      id: "eaa0dbf1-76a8-46ee-8aa1-897c245af871",
      type: "Text",
      name: "timeText",
      nameSpace: "",
      className: "",
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "03:25",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 1,
      icons: [],
      style: {
        fontSize: 16,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ffffff",
        stroke: "black",
        strokeThickness: 3,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "f88c26a1-ece9-413f-bb40-47c52c1243af",
      data: ""
    }
  ]
} as const;

export class LevelPopupFriendLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  photo: GameObject<PIXI.Sprite>;
  bg: GameObject<PIXI.Sprite>;
  nameText: GameObject<PIXI.Text>;
  scoreText: GameObject<PIXI.Text>;
  coin: GameObject<PIXI.Sprite>;
  timeText: GameObject<PIXI.Text>;

  constructor() {
    populate(this, raw);
  }
}
